import { defineMessages } from 'react-intl-next';

export const messages: {
	paddingLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	paddingLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.styles.padding-label',
		defaultMessage: 'Padding',
		description:
			'A visible text label for the padding section of the link cards config panel that informs the user that they can select either true or false.',
	},
});
